import type { BlogPost } from "../../../../mocks/blog";

const categoryColors: Record<string, string> = {
  "Product Sourcing": "bg-amber-50 text-amber-700",
  "Wholesale": "bg-[#D9E2EC] text-[#3A506B]",
  "Inventory": "bg-teal-50 text-teal-700",
  "Logistics": "bg-slate-100 text-slate-600",
  "Supply Chain": "bg-[#C9A227]/10 text-[#C9A227]",
};

interface ArticleHeaderProps {
  post: BlogPost;
}

export default function ArticleHeader({ post }: ArticleHeaderProps) {
  const catStyle = categoryColors[post.category] ?? "bg-gray-100 text-gray-600";

  return (
    <header className="max-w-3xl mx-auto px-6 lg:px-0 pt-10 pb-8">
      {/* Category */}
      <div className="flex items-center gap-3 mb-5">
        <span className={`text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full ${catStyle}`}>
          {post.category}
        </span>
        <span className="text-xs text-[#3A506B]/50">·</span>
        <span className="text-xs text-[#3A506B]/50 flex items-center gap-1">
          <i className="ri-time-line text-xs"></i>
          {post.readTime} min read
        </span>
      </div>

      {/* Title */}
      <h1 className="text-3xl lg:text-5xl font-extrabold text-[#222831] leading-tight mb-6">
        {post.title}
      </h1>

      {/* Excerpt */}
      <p className="text-base lg:text-lg text-[#3A506B] leading-relaxed mb-8">
        {post.excerpt}
      </p>

      {/* Author row */}
      <div className="flex items-center justify-between flex-wrap gap-4 pb-8 border-b border-[#E8ECF0]">
        <div className="flex items-center gap-3">
          <div
            className={`w-11 h-11 flex items-center justify-center rounded-full text-white text-sm font-bold flex-shrink-0 ${post.author.bgColor}`}
          >
            {post.author.initials}
          </div>
          <div>
            <p className="text-sm font-bold text-[#222831]">{post.author.name}</p>
            <p className="text-xs text-[#3A506B]/60">{post.author.role}</p>
          </div>
        </div>
        <div className="flex items-center gap-4 text-xs text-[#3A506B]/60">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line text-sm"></i>
            {post.date}
          </span>
        </div>
      </div>
    </header>
  );
}